// extracted by mini-css-extract-plugin
export default {"page":"NoPlatformAccess_page__awx+a","card":"NoPlatformAccess_card__13-Or"};